/** Client-only product analytics event names (PostHog). */
export const CLIENT_ANALYTICS_EVENTS = {
	walletSignup: "wallet_signup",
	onboardingCompleted: "onboarding_completed",
	coldInviteMismatchShown: "cold_invite_mismatch_shown",
	envelopeComposeSubmitted: "envelope_compose_submitted",
	envelopeSendClicked: "envelope_send_clicked",
	envelopeSendSucceeded: "envelope_send_succeeded",
	coldShareDialogShown: "cold_share_dialog_shown",
	envelopePostSendDialogShown: "envelope_post_send_dialog_shown",
	signatureCreated: "signature_created",
	signatureApplied: "signature_applied",
	upgradePlanPromptShown: "upgrade_plan_prompt_shown",
	activationChecklistViewed: "activation_checklist_viewed",
	activationChecklistStepClicked: "activation_checklist_step_clicked",
	activationChecklistDismissed: "activation_checklist_dismissed",
	activationChecklistRestored: "activation_checklist_restored",
	activationNextStepsViewed: "activation_next_steps_viewed",
	activationNextStepsDismissed: "activation_next_steps_dismissed",
	activationHintShown: "activation_hint_shown",
	activationHintDismissed: "activation_hint_dismissed",
	activationMilestoneMarked: "activation_milestone_marked",
	activationEnvelopeStarted: "activation_envelope_started",
	feedbackSubmitted: "feedback_submitted",
	partnerTrialWelcomeShown: "partner_trial_welcome_shown",
	partnerTrialWelcomeDismissed: "partner_trial_welcome_dismissed",
} as const;
